export var supportedLanguages = ["en", "cs", "sk"];
export var defaultLanguage = "en";
//# sourceMappingURL=config.js.map